import { render, staticRenderFns } from "./right-fixed.vue?vue&type=template&id=192fa9dc&scoped=true&"
import script from "./right-fixed.vue?vue&type=script&lang=js&"
export * from "./right-fixed.vue?vue&type=script&lang=js&"
import style0 from "./right-fixed.vue?vue&type=style&index=0&id=192fa9dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192fa9dc",
  null
  
)

export default component.exports